/**
 * Password validation RegEx for JavaScript
 *
 * Passwords must be
 * - At least 8 characters long, max length anything
 * - Include at least 1 lowercase letter
 * - 1 capital letter
 * - 1 number
 * - 1 special character => anything that is not a letter or a digit
 *
 * @author Gauthier Fiorentino <gauthierfiorentino.com (not actually)>
 *
 */

export default (password) => {
  if (!password) {
    return false
  }

  return (
    password.length >= 8 &&
    password.match(/.*[A-Z].*/) &&
    password.match(/.*[^A-Za-z0-9].*/) &&
    password.match(/.*[0-9].*/)
  )
}
